/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { Notifications } from "./notification.type";

export const NotificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["NotificationByUser"],
  endpoints: (builder) => ({
    fetchNotificationByUser: builder.query({
      queryFn: async () => {
        const user = auth.currentUser;
        try {
          const userId = user?.uid;
          // Vérifier que adminId est présent
          if (!userId) {
            throw new Error("User ID is required.");
          }

          // Requête Firestore pour récupérer les notification
          const notificationRef = collection(
            db,
            `users/${userId}/notifications`,
          );
          const notificationQuery = query(
            notificationRef,
            orderBy("sentAt", "desc"),
          );

          const snapshot = await getDocs(notificationQuery);
          const notifications = await Promise.all(
            snapshot.docs.map(async (docSnap) => {
              const data = docSnap.data();
              if (data.authorId) {
                const userRef = doc(db, "users", data.authorId);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                  data.author = { uid: userSnap.id, ...userSnap.data() };
                } else {
                  data.author = null;
                }
              } else {
                data.author = null;
              }

              return {
                id: docSnap.id,
                ...data,
              };
            }),
          );
          // const notifications = snapshot.docs.map((doc) => ({
          //   id: doc.id,
          //   ...doc.data(),
          // }));

          return {
            data: notifications as unknown as Notifications[],
          };
        } catch (error) {
          return { error };
        }
      },
      onCacheEntryAdded: async (
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved },
      ) => {
        // Requête Firestore en temps réel
        const user = auth.currentUser;
        const userId = user?.uid;
        const notificationRef = collection(db, `users/${userId}/notifications`);
        const notificationQuery = query(
          notificationRef,
          orderBy("sentAt", "desc"),
        );
        let unsubscribe;
        try {
          await cacheDataLoaded;
          unsubscribe = onSnapshot(notificationQuery, async (snapshot) => {
            const notification = await Promise.all(
              snapshot.docs.map(async (docSnap) => {
                const data = docSnap.data();
                if (data.authorId) {
                  const userRef = doc(db, "users", data.authorId);
                  const userSnap = await getDoc(userRef);
                  if (userSnap.exists()) {
                    data.author = { uid: userSnap.id, ...userSnap.data() };
                  } else {
                    data.author = null;
                  }
                } else {
                  data.author = null;
                }

                return {
                  id: docSnap.id,
                  ...data,
                };
              }),
            );
            // Mise à jour du cache en temps réel

            updateCachedData(() => notification as unknown as Notifications[]);
          });
        } catch (error) {
          console.error("Erreur de souscription:", error);
        }

        await cacheEntryRemoved;
        if (unsubscribe) unsubscribe();
      },
      providesTags: ["NotificationByUser"]
    }),
    // Modifier un Notification
    editNotification: builder.mutation({
      async queryFn({ id, ...data }) {
        const user = auth.currentUser;
        try {
          const userId = user?.uid;
          const docRef = doc(db, `users/${userId}/notifications`, id);
          // console.log("data send",data,id)
          await updateDoc(docRef, data);
          return {
            data: {
              data: { id, ...data },
              message: "Notification modifiée !",
            },
          };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ["NotificationByUser"],
    }),
  }),
});

export const { useEditNotificationMutation, useFetchNotificationByUserQuery } =
  NotificationApi;
